import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserStateService {
  private isAdminSubject = new BehaviorSubject<boolean>(false);
  public isAdmin$: Observable<boolean> = this.isAdminSubject.asObservable();
  
  constructor() {
    // Check initial state from localStorage
    this.checkAdminStatus();
  }
  
  checkAdminStatus(): void {
    const localUserData = localStorage.getItem('user');
    if (localUserData) {
      try {
        const userData = JSON.parse(localUserData);
        this.isAdminSubject.next(userData.isAdmin || false);
      } catch (e) {
        console.error('Error parsing user data:', e);
        this.isAdminSubject.next(false);
      }
    } else {
      this.isAdminSubject.next(false);
    }
  }
  
  setAdminStatus(isAdmin: boolean): void {
    this.isAdminSubject.next(isAdmin);
  }
  
  updateUserData(userData: any): void {
    if (userData && userData.isAdmin !== undefined) {
      this.isAdminSubject.next(userData.isAdmin);
    }
  }
  
  clearUserState(): void {
    this.isAdminSubject.next(false);
  }
}